import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {rangeDate} from 'shared/tools';
import Employee from 'main/stores/employees/Employee';

class PayPeriod extends DomainObject {
  payNumber;
  periodStartDate;
  periodEndDate;
  cutoffWarningDate;
  payDate;
  employees;
  notes;
  complete;
  currentPeriod;

  _relations = {
    _dates: [
      'periodStartDate',
      'periodEndDate',
      'cutoffWarningDate',
      'payDate'
    ],
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      payNumber: observable,
      periodStartDate: observable,
      periodEndDate: observable,
      cutoffWarningDate: observable,
      payDate: observable,
      employees: observable,
      notes: observable,
      complete: observable,
      currentPeriod: observable,
      cycleRange: computed,
      calendarCutOffWarningDate: computed,
      calendarPayDate: computed
    });

    this.merge(other);
  }

  get cycleRange() {
    return `${rangeDate(this.periodStartDate)} - ${rangeDate(this.periodEndDate)}`;
  }

  get calendarCutOffWarningDate() {
    return rangeDate(this.cutoffWarningDate);
  }

  get calendarPayDate() {
    return rangeDate(this.payDate);
  }
}

export default PayPeriod;
